<template>
  <div class="step">
    <router-link class="step-button has-margin-top" :to="{name:'orders'}">VER PEDIDOS</router-link>
    <div class="exercise">
      <h1>Step 4</h1>
    </div>
  </div>
</template>

<script>

export default {
  name: 'step-four'
}
</script>
